import React from 'react'
import { useStyles } from './ResaleProductDimensions.styles'
import { FormikProps, useFormikContext } from 'formik'
import { StandardDimensionsV2 } from '../../../../common/components/StandardDimensionsV2/StandardDimensionsV2'

import { BoxV4, PlanType } from '@labrav/react-components'

import { CustomDimension } from '../../../Subscription/RenewOfferSubscription/Dimension/CustomDimension/CustomDimension'
import { ResaleAuthorizationWithErrors } from '../../../../modules/resaleAuthorization/types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import { DiscountType } from '../../../../types/flyout'
import type { ResaleProductDimensionsProps } from '../../types'

export const ResaleProductDimensions = ({
  product,
  productId,
}: ResaleProductDimensionsProps) => {
  const formikProps =
    useFormikContext() as FormikProps<ResaleAuthorizationWithErrors>
  const { values } = formikProps
  const { classes } = useStyles()

  return (
    <BoxV4
      heading={'Product dimensions'}
      headingIcon={
        <FontAwesomeIcon
          icon={faShelves}
          style={{ width: '18px', height: '14px' }}
        />
      }
    >
      <div className={classes.root}>
        <div className={classes.upperWrapper}>
          <StandardDimensionsV2
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            addButtonName={'Add dimensions'}
            productId={productId || ''}
            isFlexible={
              values.discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS
                ? true
                : false
            }
            firstColumnName={'Dimension'}
            isResale={true}
          />
        </div>
        {!(product?.productType == PlanType.SAAS_SUBSCRIPTION) && (
          <CustomDimension
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            heading={'Custom dimensions'}
            productId={productId || ''}
            subHeading={
              'Added custom dimensions will be available in this product after authorization is published.'
            }
            isFlexible={
              values.discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS
                ? true
                : false
            }
            isResale={true}
            buttonName={'Custom dimensions'}
          />
        )}
      </div>
    </BoxV4>
  )
}
